<template>
  <div >
    <el-alert class="container" :type="alert.type" :title="alert.title" v-show="this.showAlert"/>
    <el-form>
      <el-row style='text-align: left;font-weight: bold;font-size: 18px;'>
        用戶警示設定
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label='用水狀況預設'>
            <el-radio-group v-model="settingData.usageViewTimeUnit">
              <el-radio label='hour'>正常</el-radio>
              <el-radio label='day'>日</el-radio>
              <el-radio label='week'>週</el-radio>
              <el-radio label='month'>月</el-radio>
              <el-radio label='year'>年</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label='用水指針預設'>
            <el-radio-group v-model="settingData.volumeViewTimeUnit">
              <el-radio label='hour'>正常</el-radio>
              <el-radio label='day'>日</el-radio>
              <el-radio label='week'>週</el-radio>
              <el-radio label='month'>月</el-radio>
              <el-radio label='year'>年</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span='24'>
          <div style='text-align: right'>
            <el-button
                type='primary'
                icon='el-icon-edit'
                class='filter-label float-right'
                @click='showConfirm()'
                style='box-sizing: border-box;'
            >
              修改
            </el-button>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-dialog :visible.sync="dialogFormVisible">
            <span style="font-size: 20px;font-weight: bold">請問您是否確認要修改?</span>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="updateViewSetting()">確 定</el-button>
              <el-button type="primary" @click="cacelUpdate()">取 消</el-button>
            </div>
          </el-dialog>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { viewRuleSetting } from '@/components/common'


export default {
  // 用戶顯示警示設定
  name: 'ViewSetting',
  components: {
  },
  data() {
    return {
      settingData: {
        id: undefined,
        viewType: undefined,
        usageViewTimeUnit: undefined,
        volumeViewTimeUnit: undefined
      },
      dialogFormVisible: false,
      alert: {
        type: '',
        title: ''
      },
      showAlert: false
    };
  },
  watch: {
    'alert.title': {
      handler: function() {
        setTimeout(() => {
          this.alert.type = ''
          this.alert.title = ''
          this.showAlert = false
        }, 5000)
      },
      deep: true
    }
  },
  created(){
    this.getViewRuleSetting()
    this.settingData.id = this.settingData.waterId
  },
  mounted() {
  },
  methods: {
    updateViewSetting() {
      console.log('update SettingData:',this.settingData)
      this.axios.post('/api/viewSetting/updateViewRule', this.settingData ).then( () => {
        console.log('updateViewRule success')
        this.showAlert = true
        this.alert.title = '修改成功'
        this.alert.type = 'success'
        this.dialogFormVisible = false
      }).catch( () => {
        this.showAlert = true
        this.alert.title = '修改失敗'
        this.alert.type = 'error'
        this.dialogFormVisible = false
      })
    },
    async getViewRuleSetting() {
      this.settingData = await viewRuleSetting()
    },
    showConfirm() {
      this.dialogFormVisible = true
    },
    cacelUpdate() {
      this.dialogFormVisible = false
    }

  }
}
</script>
